import { Box, Typography, useTheme } from "@mui/material";
import ArrowTickLeft from "../../../../../media/images/icons/arrow-tick-left.svg";
import MobileHeader from "../../../../layout/OwnerLayout/Header";
import InfoCircle from "../../../../../media/images/icons/info-circle";
import { useAppSelector } from "../../../../../hooks/useRedux";

import IndividualVerifyMobileNumber from "../IndividualEditProfile/VerifyMobileNumber";
import IndividualIdentityInfo from "../IndividualEditProfile/IdentityInfo";
import IndividualIdentityDocuments from "../IndividualEditProfile/IdentityDocuments";
import IndividualAccommodationInfo from "../IndividualEditProfile/AccommodationInfo";
import IndividualBankAccountInfo from "../IndividualEditProfile/BankAccountInfo";

import LegalEntityVerifyMobileNumber from "../LegalEntityEditProfile/VerifyMobileNumber";
import LegalEntityIdentityInfo from "../LegalEntityEditProfile/IdentityInfo";
import LegalEntityIdentityDocuments from "../LegalEntityEditProfile/IdentityDocuments";
import LegalEntityAccommodationInfo from "../LegalEntityEditProfile/AccommodationInfo";
import LegalEntityBankAccountInfo from "../LegalEntityEditProfile/BankAccountInfo";
import { useNavigate } from "react-router-dom";
import IsValidPhone from "./IsValidPhone";

export default function EditProfile() {
  const { ownerInfo, phoneValid } = useAppSelector((state) => state.owner);
  const theme = useTheme();

  return (
    <>
      <MobileHeader title={HeadTitle()} />

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          paddingX: "8px",
          paddingTop: "8px",
          paddingBottom: "150px",
        }}
      >
        <Box
          sx={{
            backgroundColor: "background.default",
            borderRadius: "8px",
            padding: "10px",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          <Box
            sx={{
              backgroundColor: theme.palette.secondary[50],
              display: "flex",
              alignItems: "center",
              gap: "8px",
              padding: "6px",
              borderRadius: "8px",
            }}
          >
            <InfoCircle color={theme.palette.secondary[600]} />
            <Box
              sx={{
                display: "flex",
                alignItems: "start",
                gap: "8px",
              }}
            >
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: "700",
                  color: theme.palette.secondary[600],
                }}
              >
                نکته:
              </Typography>

              <Typography
                sx={{
                  fontSize: "12px",
                  fontWeight: "700",
                  color: theme.palette.secondary[600],
                }}
              >
                اطلاعات هویتی شما با عکس مدارکی که ارسال می‌کنید باید یکی باشد،
                در صورت هرگونه مغایرت، احراز هویت شما انجام نمی‌شود.
              </Typography>
            </Box>
          </Box>
        </Box>

        {ownerInfo?.type === 0 ? (
          <>
            {!phoneValid ? <IndividualVerifyMobileNumber /> : <IsValidPhone />}
            <IndividualIdentityInfo />
            <IndividualIdentityDocuments />
            <IndividualAccommodationInfo />
            <IndividualBankAccountInfo />
          </>
        ) : (
          <>
            {!phoneValid ? <LegalEntityVerifyMobileNumber /> : <IsValidPhone />}
            <LegalEntityIdentityInfo />
            <LegalEntityIdentityDocuments />
            <LegalEntityAccommodationInfo />
            <LegalEntityBankAccountInfo />
          </>
        )}
      </Box>
    </>
  );
}

function HeadTitle() {
  const { ownerInfo } = useAppSelector((state) => state.owner);
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <Typography
        onClick={() => navigate("../profile")}
        sx={{
          color: "secondary.main",
          fontWeight: 600,
          fontSize: "14px",
          cursor: "pointer",
        }}
      >
        حساب کاربری من
      </Typography>
      <img src={ArrowTickLeft} alt="" />
      <Typography
        sx={{
          color: "secondary.main",

          fontSize: "12px",
          fontWeight: 600,
        }}
      >
        {ownerInfo?.type === 0
          ? "ویرایش اطلاعات (حقیقی)"
          : "ویرایش اطلاعات (حقوقی)"}
      </Typography>
    </Box>
  );
}
